import { render } from "./ImpersonasyonSeridi.vue?vue&type=template&id=8004acbc"
import script from "./ImpersonasyonSeridi.vue?vue&type=script&lang=js"
export * from "./ImpersonasyonSeridi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__